const Modal = ({ isOpen, children, zIndex = 30, size = "w-2/6" }) => {
    if (!isOpen) return null;

    return (
        <div className={`fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center py-5 backdrop-blur-sm`} style={{ zIndex }}>
            <div className={"h-auto max-h-full overflow-auto w-5/6 p-6 rounded-[10px] shadow-lg bg-white " + size}>
                {children}
            </div>
        </div>

    );
};

export default Modal;